export default {
      id: "icon-chevron-left-usage",
      viewBox: "0 0 8 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-chevron-left",
      toString: function () {
        return this.url;
      }
    }